var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "detailCanvas",
      staticClass: "detailContent canvas-box",
      attrs: { id: "detailCanvas" },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "title-name" }, [
          _vm._v(_vm._s(_vm.$t("data.payin_details"))),
        ]),
      ]),
      _c("div", { staticClass: "detail-card" }, [
        _c("div", { staticClass: "info-amount-txt" }, [
          _vm._v(_vm._s(_vm.$t("data.paid")) + ":"),
        ]),
        _c("div", { staticClass: "info-amount" }, [
          _vm._v(
            _vm._s(_vm.$store.getters.currency) +
              " " +
              _vm._s(
                _vm._f("toDivideWithDot")(_vm.merchantInfo.transaction_amount)
              )
          ),
        ]),
        _c("div", { staticClass: "info-amount-txt" }, [
          _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
        ]),
        _c("div", { staticClass: "info-amount" }, [
          _vm._v(
            _vm._s(_vm.$store.getters.currency) +
              " " +
              _vm._s(_vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split))
          ),
        ]),
        _c("div", {
          staticClass: "line",
          staticStyle: { "margin-top": "10px", "margin-bottom": "8px" },
        }),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id")) + "："),
          ]),
          _c(
            "div",
            {
              staticClass: "modalCol moreBlock",
              staticStyle: { "line-height": "1.5" },
            },
            [_vm._v(_vm._s(_vm.merchantInfo.merchant_order_id))]
          ),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(
              _vm._s(
                _vm.merchantInfo.transaction_status ===
                  _vm.TRANSACTION_STATUS["void"]
                  ? _vm.$t("customerService.original_transaction_id")
                  : _vm.$t("customerService.transaction_id")
              ) + "："
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "modalCol moreBlock",
              staticStyle: { "line-height": "1.5" },
            },
            [_vm._v(_vm._s(_vm.merchantInfo.transaction_id))]
          ),
        ]),
        _vm.merchantInfo.channel_reference_no
          ? _c("div", { staticClass: "modalRow flex" }, [
              _c("div", { staticClass: "modalCol col-min-width" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.$store.getters.isMX
                        ? "customerService.ph_invoice_no"
                        : "customerService.invoice_no"
                    )
                  ) + "："
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "modalCol moreBlock",
                  staticStyle: { "line-height": "1.5" },
                },
                [_vm._v(_vm._s(_vm.merchantInfo.channel_reference_no))]
              ),
            ])
          : _vm._e(),
        _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
          ? _c("div", { staticClass: "modalRow flex" }, [
              _c("div", { staticClass: "modalCol col-min-width" }, [
                _vm._v(
                  _vm._s(_vm.$t("customerService.void_transaction_id")) + "："
                ),
              ]),
              _c("div", { staticClass: "modalCol moreBlock" }, [
                _vm._v(
                  _vm._s(
                    _vm.merchantInfo.trans_void_resp &&
                      _vm.merchantInfo.trans_void_resp.void_no
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("data.payin_created")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(_vm._s(_vm.merchantInfo.transaction_create_time)),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("data.payin_completed")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(" " + _vm._s(_vm.merchantInfo.transaction_return_time)),
          ]),
        ]),
        _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
          ? _c("div", { staticClass: "modalRow flex" }, [
              _c("div", { staticClass: "modalCol col-min-width" }, [
                _vm._v(
                  _vm._s(_vm.$t("customerService.void_complete_time")) + "："
                ),
              ]),
              _c("div", { staticClass: "modalCol moreBlock" }, [
                _vm._v(
                  _vm._s(
                    _vm.merchantInfo.trans_void_resp &&
                      _vm.merchantInfo.trans_void_resp.void_complete_time
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("merchant.payment_channel")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(_vm._s(_vm.merchantInfo.channel_code)),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(
              _vm._s(
                _vm._f("strAesDecryptAndAsterisk")(_vm.merchantInfo.payer_name)
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("data.mobile")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(
              _vm._s(
                _vm._f("strAesDecryptAndAsterisk")(
                  _vm.merchantInfo.payer_mobile
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("customerService.pay_card_no")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(_vm._s(_vm.merchantInfo.desensitization_card_no || "")),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("customerService.pay_card_scheme")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(_vm._s(_vm.merchantInfo.card_scheme || "")),
          ]),
        ]),
        _c("div", { staticClass: "modalRow flex" }, [
          _c("div", { staticClass: "modalCol col-min-width" }, [
            _vm._v(_vm._s(_vm.$t("customerService.pay_card_issuer")) + "："),
          ]),
          _c("div", { staticClass: "modalCol moreBlock" }, [
            _vm._v(_vm._s(_vm.merchantInfo.card_issuer || "")),
          ]),
        ]),
        _c("div", {
          staticClass: "line",
          staticStyle: { "margin-bottom": "10px", "margin-top": "10px" },
        }),
        _c("div", { staticClass: "download-time" }, [
          _vm._v(
            _vm._s(_vm.$t("data.download_time")) +
              ": " +
              _vm._s(_vm._f("parseTime")(Date.now()))
          ),
        ]),
      ]),
      _c(
        "el-tag",
        {
          staticClass: "modalBtn tag-custom",
          attrs: {
            type: _vm.getPayTransactionStatusType(
              _vm.merchantInfo.transaction_status
            ),
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.getPayTransactionStatusMap(
                  _vm.merchantInfo.transaction_status
                )
              )
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }